angular.module('unergie.main')
.directive('jiraIssuesBlock', ($location, ApiAdmin, AlertManager, DataAccessVariables, AdminComments, ErrorCatcher, JiraService, JiraConstants, ModalService, BoFeaturesService) => ({
    restrict: 'E',
    templateUrl: '/directives/jiraIssuesBlock/jiraIssuesBlock.html',
    scope: {
        payload: '=',
        type: '=',
        summaryPrefix: '=',
        organization: '=',
    },
    link($scope) {
        const LIMIT = 20
        $scope.offset = 0
        $scope.jira = {}
        $scope.projectEpics = {}
        $scope.variables = {}
        $scope.jiraConstants = JiraConstants
        $scope.displayOpenJiraButton = BoFeaturesService.get('canOpenJira')
        $scope.accessSge = BoFeaturesService.isFeatureOn('accessSge')
        $scope.dataReady = false
        $scope.canCreateJiraIssue = true
        if ($scope.type === 'PDL') {
            $scope.canCreateJiraIssue = BoFeaturesService.isFeatureOn('canCreatePdlJiraIssue')
        }

        $scope.confirmJiraIssueSubmit = () => {
            $scope.loadingIssues = true
            let projectKey
            let epicLink
            if (['PDL', 'PCE'].includes($scope.type) && $scope.organization) {
                projectKey = $scope.organization
            } else {
                epicLink = $scope.newJiraIssue.template.epic.key
                const epicData = $scope.newJiraIssue.template.epic
                projectKey = epicData ? epicData.fields.project.key : 'exploit'
            }
            const jiraIssue = {
                summary: $scope.newJiraIssue.template.summary,
                description: `${$scope.newJiraIssue.template.description}\n\n----\n\n${$location.absUrl()}`,
                type: $scope.newJiraIssue.template.issuetype,
                epicLink,
                priority: $scope.newJiraIssue.template.priority,
                idContract: $scope.payload.id_contract || $scope.payload.id,
                enrichSummary: false,
                isDraft: $scope.payload.is_draft,
            }

            if (!['B2G', 'PDL'].includes($scope.type)) {
                _.assign(jiraIssue, {
                    idCase: $scope.newJiraIssue.template.idCase,
                    reminder: $scope.newJiraIssue.fields.reminder.hidden($scope.newJiraIssue.template) ? $scope.newJiraIssue.template.reminderCustomerCallback : $scope.newJiraIssue.template.reminder,
                    sensitive: $scope.newJiraIssue.template.sensitive,
                    selfAssign: $scope.newJiraIssue.template.selfAssign,
                })
            }

            if ($scope.type === 'CASE') {
                _.assign(jiraIssue, {
                    idCase: $scope.payload.id,
                    idPrm: $scope.payload.id_prm,
                    idCustomer: ($scope.payload.contract && $scope.payload.contract.account) ? $scope.payload.contract.account.customer_id : undefined,
                })
            }

            if (['PDL', 'PCE'].includes($scope.type)) {
                delete jiraIssue.priority
                _.assign(jiraIssue, {
                    requestType: $scope.newJiraIssue.template.epic,
                    type: 'Support',
                    brand: $scope.payload.brand,
                })
            }
            return ApiAdmin.createJiraIssue({ projectKey }, jiraIssue).$promise.then(() => {
                // Save data
                $scope.loadingIssues = false
                AlertManager.success('Issue JIRA créée')
                const comment = !['PDL', 'PCE'].includes($scope.type) ? `${$scope.newJiraIssue.template.epic.fields.epicName} - ${$scope.newJiraIssue.template.summary}` :
                    $scope.newJiraIssue.template.summary
                AdminComments.addComment({
                    object: $scope.payload.id,
                    comment: `<b>AUTOMATIQUE</b> : ✍ Tickets de suivi interne : <b>` +
                    `${comment}</b>`,
                })
                .$promise.catch(ErrorCatcher)

                // Refresh data
                $scope.fetchIssues()
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.loadingIssues = false
            })
        }

        $scope.initJiraData = () => {
            $scope.dataFetchingPromise.then(() => {
                $scope.newJiraIssue = JiraService.init($scope.projectEpics, $scope.type)
                $scope.newJiraIssue.template.summary = $scope.summaryPrefix
                $scope.newJiraIssue.template.initialSummary = $scope.summaryPrefix
            })
        }

        const getParams = (type, id) => {
            const params = {}
            params.sort = () => {
                return { created: 'desc' }
            }
            params.filter = () => {
                switch (type) {
                    case 'PDL': return { idPrm: id }
                    case 'PCE': return { idPrm: id } // for retro compatibility, to switch to idPce ...
                    case 'CONTRACT': return { idContract: id }
                    case 'CASE':
                    default: return { idCase: id }
                }
            }

            return params
        }

        $scope.fetchJIRAData = () => {
            return JiraService.getEpics()
            .then((epics) => {
                $scope.projectEpics = epics
            })
            .catch(ErrorCatcher)
        }

        $scope.fetchIssues = (offset = 0) => {
            $scope.loadingIssues = true
            let project = 'support,exploit'
            let id = $scope.payload.id
            if ($scope.type === 'PDL' && $scope.organization) {
                project = $scope.organization
                id = $scope.payload.id_prm
            }
            if ($scope.type === 'PCE' && $scope.organization) {
                project = $scope.organization
                id = $scope.payload.id_pce
            }
            return JiraService.getData(_.assign(getParams($scope.type, id), { offset, limit: LIMIT }), project).$promise.then((response) => {
                if (response.results.issues) {
                    response.results.issues = _.map(response.results.issues, (issue) => {
                        if (issue.fields.reminder) {
                            const remind = moment(issue.fields.reminder)

                            if (remind.isBefore()) {
                                issue.isToRemind = true
                            }

                            let format = 'DD/MM/YYYY HH:mm'

                            if (remind.hour() <= 2) {
                                format = 'DD/MM/YYYY'
                            }

                            issue.fields.reminder = remind.format(format)
                        }

                        return issue
                    })
                }

                $scope.jira = response.results
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.loadingIssues = false
            })
        }

        $scope.fetchPrevious = () => {
            return $scope.fetchIssues(Math.max($scope.jira.startAt - LIMIT, 0))
        }

        $scope.fetchNext = () => {
            return $scope.fetchIssues($scope.jira.startAt + LIMIT)
        }

        $scope.fetchLast = () => {
            return $scope.fetchIssues(Math.max($scope.jira.total - LIMIT, 0))
        }


        $scope.getRequestTypes = () => {
            $scope.loadingIssues = true
            return ApiAdmin.getRequestTypes({ projectName: $scope.organization }).$promise.then((requestTypes) => {
                $scope.projectEpics = requestTypes
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.loadingIssues = false
            })
        }

        $scope.openJiraCommentsModal = (event, issue) => {
            event.preventDefault()
            event.stopPropagation()
            ModalService.openModal({ type: 'jiraCommentsModal', size: 'lg' }, { idJira: issue.key, issueType: $scope.organization ? 'b2g' : 'b2c', readOnly: true })
        }

        const activate = function () {
            if (!['PCE', 'PDL'].includes($scope.type)) {
                return $scope.fetchJIRAData()
                .then(() => $scope.fetchIssues())
            }
            return $scope.getRequestTypes().then($scope.fetchIssues)
        }

        $scope.dataFetchingPromise = activate().then(() => {
            $scope.dataReady = true
        })
    },
}))
